import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import DashboardLayout from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import CRM from "@/pages/CRM";
import Pipeline from "@/pages/Pipeline";
import Broadcast from "@/pages/Broadcast";
import Automation from "@/pages/Automation";
import Analytics from "@/pages/Analytics";
import Assistant from "@/pages/Assistant";
import Billing from "@/pages/Billing";
import Connect from "@/pages/Connect";
import MetaCenter from "@/pages/MetaCenter";
import PlatformAdmin from "@/pages/PlatformAdmin";
import CustomerProfile from "@/pages/CustomerProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-4 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="crm" element={<CRM />} />
        <Route path="crm/:id" element={<CustomerProfile />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="broadcast" element={<Broadcast />} />
        <Route path="automation" element={<Automation />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="assistant" element={<Assistant />} />
        <Route path="connect" element={<Connect />} />
        <Route path="meta-center" element={<MetaCenter />} />
        <Route path="admin" element={<PlatformAdmin />} />
        <Route path="billing" element={<Billing />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
